import { __decorate } from "tslib";
import { preview } from '../../../../store';
import TextComponent from '../../Component/components/TextComponent';
import { declareComponents } from '../../modules';
import ColorComponent from '../../StyleComponents/Color.svelte';
import FontSelect from './FontSelect.svelte';
import FontSize from './FontSize.svelte';
import FontStyle from './FontStyle.svelte';
import TextAlignment from './TextAlignment.svelte';
import TextColor from './TextColor.svelte';
let item;
let TextModule = class TextModule {
    content;
    toolbarActions = [
        {
            component: FontSelect
        },
        {
            component: TextColor
        },
        {
            component: FontSize
        },
        {
            component: FontStyle
        },
        {
            component: TextAlignment
        }
    ];
    styleComponents = [
        {
            component: ColorComponent,
            props: {
                targetAttribute: 'backgroundColor'
            }
        }
    ];
    onDblClick() {
        if (!item)
            return;
        if (item.getAttribute('data-amelement'))
            item.removeAttribute('data-amelement'); // remove the am element to dettach the dynamic text element from reloading
        var range = document.createRange();
        range.selectNodeContents(item);
        var sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
    }
    onFocus = component => {
        const dynamic = component.querySelector('.dynamic');
        if (!dynamic)
            return;
        dynamic.setAttribute('contenteditable', 'true');
        component.addEventListener('dblclick', this.onDblClick);
        this.content = dynamic.textContent;
        item = dynamic;
    };
    onUnfocus = component => {
        var sel = window.getSelection();
        sel?.removeAllRanges();
        const dynamic = component.querySelector('.dynamic');
        if (dynamic) {
            dynamic.removeAttribute('contenteditable');
            this.detectDynamicElementChange(component, dynamic.textContent);
        }
        component.removeEventListener('dblclick', this.onDblClick);
        item = null;
    };
    detectDynamicElementChange(component, updatedValue) {
        if (component.getAttribute('data-amelement')) {
            const attribute = component.getAttribute('data-amelement');
            if (attribute == 'sermon title')
                preview.set({
                    title: updatedValue || ``
                });
        }
    }
};
TextModule = __decorate([
    declareComponents([TextComponent])
], TextModule);
export default TextModule;
